export const messages = {
  en: {
    accountManage: {
      searchTitle: "Search Conditions",
      ownerAccount: "Owner Account",
      accountId: "Account ID",
      accountName: "Account Name",
      idCard: "ID Card",
      phone: "Phone",
      accountType: "Account Type",
      accountAmount: "Account Amount",
      deductionRoom: "Deduction Room",
      createTime: "Create Time",
      operations: "Operations",
      accountDetail: "Account Details",
      delete: "Delete",
      prestore: "Prestore",
      query: "Query",
      reset: "Reset",
      placeholderName: "Please enter account name",
      placeholderIdCard: "Please enter ID card number",
      placeholderLink: "Please enter contact information"
    },
    prestoreAccount: {
      title: "Prestore",
      accountType: "Account Type",
      ownerPhone: "Owner Phone",
      ownerName: "Owner Name",
      deductionRoom: "Deduction Room",
      prestoreAmount: "Prestore Amount",
      paymentMethod: "Payment Method",
      remark: "Remark",
      placeholderPhone: "Required, please enter owner phone",
      placeholderOwner: "Required, please select owner",
      placeholderRoom: "Required, please select room",
      placeholderAmount: "Required, please enter prestore amount",
      placeholderPayment: "Required, please select payment method",
      placeholderRemark: "Optional, please enter remark",
      save: "Save",
      cancel: "Cancel"
    },
    deleteAccount: {
      title: "Please confirm your operation!",
      confirmDelete: "Confirm to delete deposit?",
      cancel: "Cancel",
      confirm: "Confirm Delete"
    }
  },
  zh: {
    accountManage: {
      searchTitle: "查询条件",
      ownerAccount: "业主账户",
      accountId: "账户编号",
      accountName: "账户名称",
      idCard: "身份证号",
      phone: "手机号",
      accountType: "账户类型",
      accountAmount: "账户金额",
      deductionRoom: "扣款房号",
      createTime: "创建时间",
      operations: "操作",
      accountDetail: "账户明细",
      delete: "删除",
      prestore: "预存",
      query: "查询",
      reset: "重置",
      placeholderName: "请输入账户名称",
      placeholderIdCard: "请输入身份证号",
      placeholderLink: "请输入联系方式"
    },
    prestoreAccount: {
      title: "预存",
      accountType: "账户类型",
      ownerPhone: "业主手机",
      ownerName: "业主名称",
      deductionRoom: "扣款房屋",
      prestoreAmount: "预存金额",
      paymentMethod: "支付方式",
      remark: "备注",
      placeholderPhone: "必填，请填写业主手机号",
      placeholderOwner: "必填，请选择业主",
      placeholderRoom: "必填，请选择房屋",
      placeholderAmount: "必填，请填写预存金额",
      placeholderPayment: "必填，请选择支付方式",
      placeholderRemark: "可填，请填写备注",
      save: "保存",
      cancel: "取消"
    },
    deleteAccount: {
      title: "请确认您的操作!",
      confirmDelete: "确定删除保证金",
      cancel: "点错了",
confirm: "确认删除"
    }
  },
  'zh-TW': {
    accountManage: {
      searchTitle: "查詢條件",
      ownerAccount: "業主賬戶",
      accountId: "賬戶編號",
      accountName: "賬戶名稱",
      idCard: "身份證號",
      phone: "手機號",
      accountType: "賬戶類型",
      accountAmount: "賬戶金額",
      deductionRoom: "扣款房號",
      createTime: "創建時間",
      operations: "操作",
      accountDetail: "賬戶明細",
      delete: "刪除",
      prestore: "預存",
      query: "查詢",
      reset: "重置",
      placeholderName: "請輸入賬戶名稱",
      placeholderIdCard: "請輸入身份證號",
      placeholderLink: "請輸入聯絡方式"
    },
    prestoreAccount: {
      title: "預存",
      accountType: "賬戶類型",
      ownerPhone: "業主手機",
      ownerName: "業主名稱",
      deductionRoom: "扣款房屋",
      prestoreAmount: "預存金額",
      paymentMethod: "支付方式",
      remark: "備註",
      placeholderPhone: "必填，請填寫業主手機號",
      placeholderOwner: "必填，請選擇業主",
      placeholderRoom: "必填，請選擇房屋",
      placeholderAmount: "必填，請填寫預存金額",
      placeholderPayment: "必填，請選擇支付方式",
      placeholderRemark: "可填，請填寫備註",
      save: "保存",
      cancel: "取消"
    },
    deleteAccount: {
      title: "請確認您的操作!",
      confirmDelete: "確定刪除保證金",
      cancel: "點錯了",
      confirm: "確認刪除"
    }
  }
}